<template>

    <header class="z-20 bg-black">

        <nav class="flex items-center justify-between flex-wrap py-3 px-3 md:px-0 w-full">
            <router-link to="/" class="flex items-center flex-no-shrink text-white md:mr-6 content-center pl-5">
                <h2>{{ network.toUpperCase() }}</h2>
            </router-link>
        </nav>

    </header>

</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Navbar',
        data() {
            return {
              open: false,
            }
        },
        props: ['network'],
    }
</script>

<style>
    nav a {
      text-decoration: none;
    }
</style>
